<template>
  <section v-if="newBizParam">
    <!-- 规则1 start-->
    <div
      class="rule"
      style="border-top: 1px solid #d9d9d9; padding-top: 16px; margin-top: 16px"
    >
      <h5>订单条数/盒数限制：</h5>
      <el-checkbox
        @change="
          changeCheck(1);
          $emit('changeData', newBizParam);
        "
        v-model="newBizParam.dayBizDataSum.enabled"
      ></el-checkbox>
      <span class="txt">规则1：同一人同一天提交订单数最多</span>
      <div
        :class="
          !newBizParam.dayBizDataSum.limitMax &&
          newBizParam.dayBizDataSum.enabled &&
          isOpenCheck
            ? 'red-border'
            : ''
        "
      >
        <el-input
          :disabled="!newBizParam.dayBizDataSum.enabled"
          class="rule-input-box"
          v-model="newBizParam.dayBizDataSum.limitMax"
          @input="
            $forceUpdate();
            $emit('changeData', newBizParam);
          "
          oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
          type="text"
          :min="1"
          :maxlength="7"
        ></el-input>
      </div>

      <span class="txt">条</span>
      <p
        class="tips"
        v-if="
          !newBizParam.dayBizDataSum.limitMax &&
          newBizParam.dayBizDataSum.enabled &&
          isOpenCheck
        "
      >
        请将规则填写完整
      </p>
    </div>
    <!-- 规则1 end-->

    <!-- 规则2 start-->
    <template
      v-if="
        $route.query.functionCode == 'BHOTC' ||
        $route.query.functionCode == 'BHSY'
      "
    >
      <div class="rule">
        <h5></h5>
        <el-checkbox
          @change="
            changeCheck(2);
            $emit('changeData', newBizParam);
          "
          v-model="newBizParam.selectProductQtySum.enabled"
        ></el-checkbox>
        <span class="txt">规则2：限制同一人员提交每笔订单的数量上限</span>
      </div>
      <div class="rule-child" v-if="newBizParam.selectProductQtySum.enabled">
        <div
          class="rule"
          v-for="(item, index) in newBizParam.selectProductQtySum.ruleItemList"
          :key="index"
        >
          <el-checkbox
            @change="
              item.sumLimitMax = null;
              $forceUpdate();
              $emit('changeData', newBizParam);
            "
            v-model="item.enabled"
          ></el-checkbox>
          <span class="txt"
            ><i class="theme-color">{{ item.customerType }}</i
            >最多提交<span
              :class="
                !item.sumLimitMax && item.enabled && isOpenCheck
                  ? 'red-border txt'
                  : 'txt'
              "
              ><el-input
                @input="
                  $forceUpdate();
                  $emit('changeData', newBizParam);
                "
                class="rule-input-box"
                v-model="item.sumLimitMax"
                oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                type="text"
                :min="1"
                :maxlength="7"
                :disabled="!item.enabled"
              ></el-input></span
            >盒</span
          >
          <p
            class="tips"
            v-if="!item.sumLimitMax && item.enabled && isOpenCheck"
          >
            请将规则填写完整
          </p>
        </div>
      </div>
    </template>
    <!-- 规则2 end-->

    <!-- 规则2 start-->
    <template v-if="$route.query.functionCode == 'BHRX'">
      <div class="rule">
        <h5></h5>
        <el-checkbox
          @change="
            changeCheck(2);
            $emit('changeData', newBizParam);
          "
          v-model="newBizParam.selectMedProductQtySum.enabled"
        ></el-checkbox>
        <span class="txt">规则2：限制同一人员提交每笔订单的数量上限</span>
      </div>
      <div class="rule-child" v-if="newBizParam.selectMedProductQtySum.enabled">
        <div
          class="rule"
          v-for="(item, index) in newBizParam.selectMedProductQtySum
            .ruleItemList"
          :key="index"
        >
          <el-checkbox
            @change="
              item.sumLimitMax = null;
              $forceUpdate();
              $emit('changeData', newBizParam);
            "
            v-model="item.enabled"
          ></el-checkbox>
          <span class="txt"
            ><i class="theme-color">{{ item.orgType }}</i
            >最多提交<span
              :class="
                !item.sumLimitMax && item.enabled && isOpenCheck
                  ? 'red-border txt'
                  : 'txt'
              "
              ><el-input
                @input="
                  $forceUpdate();
                  $emit('changeData', newBizParam);
                "
                class="rule-input-box"
                v-model="item.sumLimitMax"
                oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                type="text"
                :min="1"
                :maxlength="7"
                :disabled="!item.enabled"
              ></el-input></span
            >盒</span
          >
          <p
            class="tips"
            v-if="!item.sumLimitMax && item.enabled && isOpenCheck"
          >
            请将规则填写完整
          </p>
        </div>
      </div>
    </template>
    <!-- 规则2 end-->

    <!-- 规则3 start-->
    <div
      class="rule"
      style="border-top: 1px solid #d9d9d9; padding-top: 16px; margin-top: 16px"
    >
      <h5>重复性限制：</h5>
      <el-checkbox
        @change="
          changeCheck(3);
          $emit('changeData', newBizParam);
        "
        v-model="newBizParam.monthOrderSumProduct.enabled"
      ></el-checkbox>
      <span class="txt"
        >规则3：同企业所有人同一核算月内，采集同客户同渠道同报货类型<i
          class="theme-color"
          >同产品名称同规格/批号同厂家</i
        >的数据最多</span
      >
      <div
        :class="
          !newBizParam.monthOrderSumProduct.limitMax &&
          newBizParam.monthOrderSumProduct.enabled &&
          isOpenCheck
            ? 'red-border'
            : ''
        "
      >
        <el-input
          :disabled="!newBizParam.monthOrderSumProduct.enabled"
          class="rule-input-box"
          v-model="newBizParam.monthOrderSumProduct.limitMax"
          @input="
            $forceUpdate();
            $emit('changeData', newBizParam);
          "
          oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
          type="text"
          :min="1"
          :maxlength="7"
        ></el-input>
      </div>
      <span class="txt">条</span>
      <p
        class="tips"
        v-if="
          !newBizParam.monthOrderSumProduct.limitMax &&
          newBizParam.monthOrderSumProduct.enabled &&
          isOpenCheck
        "
      >
        请将规则填写完整
      </p>
    </div>
    <!-- 规则3 end-->
    <!-- 规则4 start-->
    <div class="rule">
      <h5></h5>
      <el-checkbox
        @change="
          changeCheck(4);
          $emit('changeData', newBizParam);
        "
        v-model="newBizParam.monthOrderSumCompetitor.enabled"
      ></el-checkbox>
      <span class="txt"
        >规则4：同企业所有人同一核算月内，采集同客户同渠道同报货类型<i
          class="theme-color"
          >同竞品名称同规格/批号同厂家</i
        >的数据最多</span
      >
      <div
        :class="
          !newBizParam.monthOrderSumCompetitor.limitMax &&
          newBizParam.monthOrderSumCompetitor.enabled &&
          isOpenCheck
            ? 'red-border'
            : ''
        "
      >
        <el-input
          :disabled="!newBizParam.monthOrderSumCompetitor.enabled"
          class="rule-input-box"
          v-model="newBizParam.monthOrderSumCompetitor.limitMax"
          @input="
            $forceUpdate();
            $emit('changeData', newBizParam);
          "
          oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
          type="text"
          :min="1"
          :maxlength="7"
        ></el-input>
      </div>
      <span class="txt">条</span>
      <p
        class="tips"
        v-if="
          !newBizParam.monthOrderSumCompetitor.limitMax &&
          newBizParam.monthOrderSumCompetitor.enabled &&
          isOpenCheck
        "
      >
        请将规则填写完整
      </p>
    </div>
    <!-- 规则4 end-->
    <!-- 规则5 start-->
    <div class="rule">
      <h5></h5>
      <!-- <p class="rule-title">数据重复性拦截：</p> -->
      <el-checkbox
        @change="$emit('changeData', newBizParam)"
        v-model="newBizParam.orderRepeatIntercept"
      ></el-checkbox>
      <span class="txt"
        >规则5：同企业所有人同一天内，采集同客户同渠道同报货类型<i
          class="theme-color"
          >同产品名称同规格/批号同厂家</i
        >的数据不可重复</span
      >
      <el-tooltip class="item" effect="light" placement="top-start">
        <div slot="content">
          同企业所有人中，同一天采集同客户名称、同渠道（商业公司）、同报货类型、<i
            class="tips-color"
            >同产品名称同规格/批号同厂家</i
          >的单据进行拦截提示"您提交了重复的单据，请调整"。
        </div>
        <i class="el-icon-question" style="color: #606266"></i>
      </el-tooltip>
    </div>
    <!-- 规则5 end-->

    <!-- 规则6 start-->
    <div
      class="rule"
      style="border-top: 1px solid #d9d9d9; padding-top: 16px; margin-top: 16px"
    >
      <h5>客户限制:</h5>
      <el-checkbox
        @change="
          changeCheck(6);
          $emit('changeData', newBizParam);
        "
        v-model="newBizParam.dayCustomerSumAndSame.enabled"
      ></el-checkbox>
      <span class="txt">规则6：限制</span>
      <div
        :class="
          !newBizParam.dayCustomerSumAndSame.isSamePerson &&
          newBizParam.dayCustomerSumAndSame.enabled &&
          isOpenCheck
            ? 'red-border'
            : ''
        "
      >
        <el-select
          @change="$emit('changeData', newBizParam)"
          :disabled="!newBizParam.dayCustomerSumAndSame.enabled"
          class="w130"
          v-model="newBizParam.dayCustomerSumAndSame.isSamePerson"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="(item, index) in isSamePersonOption"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <span class="txt"
        ><i class="theme-color">同一天</i>采集<i class="theme-color">企业客户</i
        >的频次</span
      >
      <p
        class="tips"
        v-if="
          !newBizParam.dayCustomerSumAndSame.isSamePerson &&
          newBizParam.dayCustomerSumAndSame.enabled &&
          isOpenCheck
        "
      >
        请将规则填写完整
      </p>
    </div>
    <div class="rule-child" v-if="newBizParam.dayCustomerSumAndSame.enabled">
      <div
        class="rule"
        v-for="(item, index) in dayCustomerSumAndSameRuleItemList"
        :key="index"
      >
        <el-checkbox
          @change="
            item.sameLimitMax = null;
            item.sumLimitMax = null;
            $forceUpdate();
            $emit('changeData', newBizParam);
          "
          v-model="item.enabled"
        ></el-checkbox>
        <span class="txt"
          ><i class="theme-color"> {{ CUSTOMERTYPEMAP[item.customerType] }} </i
          >不可超过<span
            :class="
              !item.sumLimitMax && item.enabled && isOpenCheck
                ? 'red-border txt'
                : 'txt'
            "
            ><el-input
              class="rule-input-box"
              v-model="item.sumLimitMax"
              @input="
                $forceUpdate();
                $emit('changeData', newBizParam);
              "
              oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
              type="text"
              :min="1"
              :maxlength="7"
              :disabled="!item.enabled"
            ></el-input></span
          >次，同一家不可超过<span
            :class="
              !item.sameLimitMax && item.enabled && isOpenCheck
                ? 'red-border txt'
                : 'txt'
            "
            ><el-input
              class="rule-input-box"
              v-model="item.sameLimitMax"
              @input="
                $forceUpdate();
                $emit('changeData', newBizParam);
              "
              oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
              type="text"
              :min="1"
              :maxlength="7"
              :disabled="!item.enabled"
            ></el-input></span
          >次</span
        >
        <p
          class="tips"
          v-if="
            (!item.sameLimitMax || !item.sumLimitMax) &&
            item.enabled &&
            isOpenCheck
          "
        >
          请将规则填写完整
        </p>
      </div>
    </div>

    <!-- 规则7 start-->
    <div class="rule">
      <h5></h5>
      <el-checkbox
        @change="
          changeCheck(7);
          $emit('changeData', newBizParam);
        "
        v-model="newBizParam.dayCustomerSameSum.enabled"
      ></el-checkbox>
      <span class="txt">规则7：限制 </span>
      <div
        :class="
          !newBizParam.dayCustomerSameSum.isSamePerson &&
          newBizParam.dayCustomerSameSum.enabled &&
          isOpenCheck
            ? 'red-border'
            : ''
        "
      >
        <el-select
          @change="$emit('changeData', newBizParam)"
          :disabled="!newBizParam.dayCustomerSameSum.enabled"
          class="w130"
          v-model="newBizParam.dayCustomerSameSum.isSamePerson"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="(item, index) in isSamePersonOption"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <span class="txt"
        ><i class="theme-color">同一天</i>采集<i class="theme-color">同一家企业客户</i
        >的频次</span
      >
      <p
        class="tips"
        v-if="
          !newBizParam.dayCustomerSameSum.isSamePerson &&
          newBizParam.dayCustomerSameSum.enabled &&
          isOpenCheck
        "
      >
        请将规则填写完整
      </p>
    </div>
    <div class="rule-child" v-if="newBizParam.dayCustomerSameSum.enabled">
      <div
        class="rule"
        v-for="(item, index) in dayCustomerSameSumRuleItemList"
        :key="index"
      >
        <el-checkbox
          @change="
            item.sumLimitMax = null;
            $forceUpdate();
            $emit('changeData', newBizParam);
          "
          v-model="item.enabled"
        ></el-checkbox>
        <span class="txt"
          ><i class="theme-color">{{ CUSTOMERTYPEMAP[item.customerType] }}</i
          >不可超过<span
            :class="
              !item.sumLimitMax && item.enabled && isOpenCheck
                ? 'red-border txt'
                : 'txt'
            "
            ><el-input
              @input="
                $forceUpdate();
                $emit('changeData', newBizParam);
              "
              class="rule-input-box"
              v-model="item.sumLimitMax"
              oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
              type="text"
              :min="1"
              :maxlength="7"
              :disabled="!item.enabled"
            ></el-input></span
          >次</span
        >
        <p class="tips" v-if="!item.sumLimitMax && item.enabled && isOpenCheck">
          请将规则填写完整
        </p>
      </div>
    </div>
    <!-- 规则7 end-->

    <!-- 规则8 start-->
    <div class="rule">
      <h5></h5>
      <el-checkbox
        @change="
          changeCheck(8);
          $emit('changeData', newBizParam);
        "
        v-model="newBizParam.monthCustomerSameStaff.enabled"
      ></el-checkbox>
      <span class="txt">规则8：限制 </span>
      <div
        :class="
          !newBizParam.monthCustomerSameStaff.isSamePerson &&
          newBizParam.monthCustomerSameStaff.enabled &&
          isOpenCheck
            ? 'red-border'
            : ''
        "
      >
        <el-select
          @change="$emit('changeData', newBizParam)"
          :disabled="true"
          class="w130"
          placeholder="请选择"
          :value="isSamePersonOption[0].value"
        >
          <el-option
            v-for="(item, index) in isSamePersonOption"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <span class="txt"
        ><i class="theme-color">同一月</i>采集<i class="theme-color">采集同一家企业客户</i
        >的频次</span
      >
      <p
        class="tips"
        v-if="
          !newBizParam.monthCustomerSameStaff.isSamePerson &&
          newBizParam.monthCustomerSameStaff.enabled &&
          isOpenCheck
        "
      >
        请将规则填写完整
      </p>
    </div>
    <div class="rule-child" v-if="newBizParam.monthCustomerSameStaff.enabled">
      <div
        class="rule"
        v-for="(item, index) in monthCustomerSameStaffRuleItemList"
        :key="index"
      >
        <el-checkbox
          @change="
            item.sumLimitMax = null;
            $forceUpdate();
            $emit('changeData', newBizParam);
          "
          v-model="item.enabled"
        ></el-checkbox>
        <span class="txt"
          ><i class="theme-color">{{ CUSTOMERTYPEMAP[item.customerType] }}</i
          >不可超过<span
            :class="
              !item.sumLimitMax && item.enabled && isOpenCheck
                ? 'red-border txt'
                : 'txt'
            "
            ><el-input
              @input="
                $forceUpdate();
                $emit('changeData', newBizParam);
              "
              class="rule-input-box"
              v-model="item.sumLimitMax"
              oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
              type="text"
              :min="1"
              :maxlength="7"
              :disabled="!item.enabled"
            ></el-input></span
          >次</span
        >
        <p class="tips" v-if="!item.sumLimitMax && item.enabled && isOpenCheck">
          请将规则填写完整
        </p>
      </div>
    </div>
    <!-- 规则8 end-->

    <!-- 规则9 start-->
    <div class="rule">
      <h5></h5>
      <el-checkbox
        @change="
          changeCheck(9);
          $emit('changeData', newBizParam);
        "
        v-model="newBizParam.monthCustomerDifferentStaff.enabled"
      ></el-checkbox>
      <span class="txt">规则9：限制 </span>
      <div
        :class="
          !newBizParam.monthCustomerDifferentStaff.isSamePerson &&
          newBizParam.monthCustomerDifferentStaff.enabled &&
          isOpenCheck
            ? 'red-border'
            : ''
        "
      >
        <el-select
          @change="$emit('changeData', newBizParam)"
          :disabled="true"
          class="w130"
          placeholder="请选择"
          :value="isSamePersonOption[1].value"
        >
          <el-option
            v-for="(item, index) in isSamePersonOption"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <span class="txt"
        ><i class="theme-color">同一月</i>采集<i class="theme-color">采集同一家企业客户</i
        >的频次</span
      >
      <p
        class="tips"
        v-if="
          !newBizParam.monthCustomerDifferentStaff.isSamePerson &&
          newBizParam.monthCustomerDifferentStaff.enabled &&
          isOpenCheck
        "
      >
        请将规则填写完整
      </p>
    </div>
    <div
      class="rule-child"
      v-if="newBizParam.monthCustomerDifferentStaff.enabled"
    >
      <div
        class="rule"
        v-for="(item, index) in monthCustomerDifferentStaffRuleItemList"
        :key="index"
      >
        <el-checkbox
          @change="
            item.sumLimitMax = null;
            $forceUpdate();
            $emit('changeData', newBizParam);
          "
          v-model="item.enabled"
        ></el-checkbox>
        <span class="txt"
          ><i class="theme-color">{{ CUSTOMERTYPEMAP[item.customerType] }}</i
          >不可超过<span
            :class="
              !item.sumLimitMax && item.enabled && isOpenCheck
                ? 'red-border txt'
                : 'txt'
            "
            ><el-input
              @input="
                $forceUpdate();
                $emit('changeData', newBizParam);
              "
              class="rule-input-box"
              v-model="item.sumLimitMax"
              oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
              type="text"
              :min="1"
              :maxlength="7"
              :disabled="!item.enabled"
            ></el-input></span
          >次</span
        >
        <p class="tips" v-if="!item.sumLimitMax && item.enabled && isOpenCheck">
          请将规则填写完整
        </p>
      </div>
    </div>
    <!-- 规则9 end-->
  </section>
</template>

<script>
import { CUSTOMERTYPEMAP, CustomerTypeEnum } from "./enum.js";
export default {
  props: ["bizParam1", "queryCode"],
  data() {
    return {
      CUSTOMERTYPEMAP,
      CustomerTypeEnum,
      isOpenCheck: false,
      newBizParam: null,
      isSamePersonOption: [
        {
          value: "Y",
          label: "同一人员",
        },
        {
          value: "N",
          label: "不同人员",
        },
      ],
    };
  },
  watch: {
    bizParam1: {
      deep: true,
      handler(newBizParam) {
        if (!this.$route.query.guid && this.$route.query.type != 3) return;
        this.newBizParam = JSON.parse(JSON.stringify(newBizParam));
        this.$forceUpdate();
      },
    },
  },
  created() {
    if (this.$route.query.guid || this.$route.query.type == 3) return;
    this.newBizParam = this.bizParam1;
    this.changeCheck(0);
  },
  methods: {
    changeCheck(i) {
      // 规则1
      if (!this.newBizParam.dayBizDataSum.enabled && (i == 1 || i == 0)) {
        this.newBizParam.dayBizDataSum = {
          enabled: false,
          limitMax: null,
        };
      }
      //规则2
      if (!this.newBizParam.selectProductQtySum.enabled && (i == 2 || i == 0)) {
        //药店
        if (this.$route.query.functionCode == "BHOTC") {
          this.newBizParam.selectProductQtySum = {
            enabled: false,
            ruleItemList: [
              {
                enabled: false,
                customerType: "单体药店",
                sumLimitMax: null,
              },
              {
                enabled: false,
                customerType: "连锁总部",
                sumLimitMax: null,
              },
              {
                enabled: false,
                customerType: "连锁门店",
                sumLimitMax: null,
              },
              {
                enabled: false,
                customerType: "未定义类型的药店",
                sumLimitMax: null,
              },
            ],
          };
        }
        //商业
        if (this.$route.query.functionCode == "BHSY") {
          this.newBizParam.selectProductQtySum = {
            enabled: false,
            ruleItemList: [
              {
                enabled: false,
                customerType: "商业公司",
                sumLimitMax: null,
              },
            ],
          };
        }
      }
      //规则2
      if (
        (!this.newBizParam.selectMedProductQtySum ||
          !this.newBizParam.selectMedProductQtySum.enabled) &&
        (i == 2 || i == 0)
      ) {
        //医院
        if (this.$route.query.functionCode == "BHRX") {
          this.newBizParam.selectMedProductQtySum = {
            enabled: false,
            ruleItemList: [
              {
                enabled: false,
                orgType: "医院",
                sumLimitMax: null,
              },
              {
                enabled: false,
                orgType: "保健院",
                sumLimitMax: null,
              },
              {
                enabled: false,
                orgType: "诊所",
                sumLimitMax: null,
              },
              {
                enabled: false,
                orgType: "门诊",
                sumLimitMax: null,
              },
              {
                enabled: false,
                orgType: "社区服务中心",
                sumLimitMax: null,
              },
              {
                enabled: false,
                orgType: "乡镇卫生院/室",
                sumLimitMax: null,
              },
              {
                enabled: false,
                orgType: "民营医院",
                sumLimitMax: null,
              },
              {
                enabled: false,
                orgType: "专科疾病防治院/所/站",
                sumLimitMax: null,
              },
              {
                enabled: false,
                orgType: "急救中心/站",
                sumLimitMax: null,
              },
              {
                enabled: false,
                orgType: "其他基层医疗",
                sumLimitMax: null,
              },
              {
                enabled: false,
                orgType: "其他机构",
                sumLimitMax: null,
              },
              {
                enabled: false,
                orgType: "未定义类别的",
                sumLimitMax: null,
              },
            ],
          };
        }
      }
      //规则3
      if (
        !this.newBizParam.monthOrderSumProduct.enabled &&
        (i == 3 || i == 0)
      ) {
        this.newBizParam.monthOrderSumProduct = {
          enabled: false,
          limitMax: null,
        };
      }
      if (
        !this.newBizParam.monthOrderSumCompetitor.enabled &&
        (i == 4 || i == 0)
      ) {
        this.newBizParam.monthOrderSumCompetitor = {
          enabled: false,
          limitMax: null,
        };
      }
      /**规则6 */
      if (
        !this.newBizParam.dayCustomerSumAndSame.enabled &&
        (i == 6 || i == 0)
      ) {
        this.newBizParam.dayCustomerSumAndSame = {
          ...this.newBizParam.dayCustomerSumAndSame,
          enabled: false,
          isSamePerson: null,
          ruleItemList: this.newBizParam.dayCustomerSumAndSame.ruleItemList.map(
            (item) => {
              return {
                ...item,
                enabled: false,
                sumLimitMax: null,
                sameLimitMax: null,
              };
            }
          ),
        };
      }

      // 规则7
      if (!this.newBizParam.dayCustomerSameSum.enabled && (i == 7 || i == 0)) {
        this.newBizParam.dayCustomerSameSum = {
          ...this.newBizParam.dayCustomerSameSum,
          enabled: false,
          isSamePerson: null,
          ruleItemList: this.newBizParam.dayCustomerSameSum.ruleItemList.map(
            (item) => {
              return {
                ...item,
                enabled: false,
                sumLimitMax: null,
              };
            }
          ),
        };
      }

      // 规则8
      if (
        !this.newBizParam.monthCustomerSameStaff.enabled &&
        (i == 8 || i == 0)
      ) {
        this.newBizParam.monthCustomerSameStaff = {
          ...this.newBizParam.monthCustomerSameStaff,
          enabled: false,
          isSamePerson: this.isSamePersonOption[0].value,
          ruleItemList:
            this.newBizParam.monthCustomerSameStaff.ruleItemList.map((item) => {
              return {
                ...item,
                enabled: false,
                sumLimitMax: null,
              };
            }),
        };
      }

      if (
        !this.newBizParam.monthCustomerDifferentStaff.enabled &&
        (i == 9 || i == 0)
      ) {
        this.newBizParam.monthCustomerDifferentStaff = {
          ...this.newBizParam.monthCustomerDifferentStaff,
          enabled: false,
          isSamePerson: this.isSamePersonOption[1].value,
          ruleItemList:
            this.newBizParam.monthCustomerDifferentStaff.ruleItemList.map(
              (item) => {
                return {
                  ...item,
                  enabled: false,
                  sumLimitMax: null,
                  sameLimitMax: null,
                };
              }
            ),
        };
      }
      this.$forceUpdate();
    },
    checkResult() {
      this.isOpenCheck = true;
      this.$forceUpdate();
      let {
        dayBizDataSum,
        selectMedProductQtySum,
        selectProductQtySum,
        monthOrderSumProduct,
        monthOrderSumCompetitor,
        orderDayCustomerSameSum,
        dayCustomerSumAndSame,
        dayCustomerSameSum,
        monthCustomerSameStaff,
        monthCustomerDifferentStaff,
      } = this.newBizParam;
      //规则1 校验
      if (dayBizDataSum.enabled && !dayBizDataSum.limitMax) return;
      //规则3 校验
      if (monthOrderSumProduct.enabled && !monthOrderSumProduct.limitMax)
        return;
      if (monthOrderSumCompetitor.enabled && !monthOrderSumCompetitor.limitMax)
        return;
      //规则2 校验
      try {
        let count = 0;
        let list =
          this.$route.query.functionCode == "BHRX"
            ? 12
            : this.$route.query.functionCode == "BHSY"
            ? 1
            : 4;
        if (this.$route.query.functionCode == "BHRX") {
          selectMedProductQtySum.ruleItemList.forEach((k) => {
            if (selectMedProductQtySum.enabled && !k.enabled) {
              count++;
            }
            if (count == list) {
              throw new Error("请至少勾选一个限制规则 22222");
            }
            if (k.enabled && !k.sumLimitMax) {
              throw new Error("");
            }
          });
        }

        if (["BHSY", "BHOTC"].includes(this.$route.query.functionCode)) {
          selectProductQtySum.ruleItemList.forEach((k) => {
            if (selectProductQtySum.enabled && !k.enabled) {
              count++;
            }
            if (count == list) {
              throw new Error("请至少勾选一个限制规则");
            }
            if (k.enabled && !k.sumLimitMax) {
              throw new Error("");
            }
          });
        }
      } catch (e) {
        if (e.message) {
          this.$message.error(e.message);
        }
        return;
      }

      // 规则6校验
      try {
        const hasEnabledRule = this.dayCustomerSumAndSameRuleItemList.some(
          (item) => item.enabled
        );

        if (dayCustomerSumAndSame.enabled) {
          if (!hasEnabledRule) {
            throw new Error("请至少勾选一个限制规则");
          }

          const invalidRule = this.dayCustomerSumAndSameRuleItemList.find(
            (item) => item.enabled && (!item.sumLimitMax || !item.sameLimitMax)
          );

          if (invalidRule) {
            throw new Error("");
          }
        }
      } catch (e) {
        if (e.message) {
          this.$message.error(e.message);
        }
        return;
      }

      // 规则7校验
      try {
        const hasEnabledRule = this.dayCustomerSameSumRuleItemList.some(
          (item) => item.enabled
        );

        if (dayCustomerSameSum.enabled) {
          if (!hasEnabledRule) {
            throw new Error("请至少勾选一个限制规则");
          }

          const invalidRule = this.dayCustomerSameSumRuleItemList.find(
            (item) => item.enabled && !item.sumLimitMax
          );

          if (invalidRule) {
            throw new Error("");
          }
        }
      } catch (e) {
        if (e.message) {
          this.$message.error(e.message);
        }
        return;
      }
      // 规则8校验
      try {
        const hasEnabledRule = this.monthCustomerSameStaffRuleItemList.some(
          (item) => item.enabled
        );

        if (monthCustomerSameStaff.enabled) {
          if (!hasEnabledRule) {
            throw new Error("请至少勾选一个限制规则");
          }

          const invalidRule = this.monthCustomerSameStaffRuleItemList.find(
            (item) => item.enabled && !item.sumLimitMax
          );

          if (invalidRule) {
            throw new Error("");
          }
        }
      } catch (e) {
        if (e.message) {
          this.$message.error(e.message);
        }
        return;
      }
      // 规则9校验
      try {
        const hasEnabledRule =
          this.monthCustomerDifferentStaffRuleItemList.some(
            (item) => item.enabled
          );
        if (monthCustomerDifferentStaff.enabled) {
          if (!hasEnabledRule) {
            throw new Error("请至少勾选一个限制规则");
          }

          const invalidRule = this.monthCustomerDifferentStaffRuleItemList.find(
            (item) => item.enabled && !item.sumLimitMax
          );

          if (invalidRule) {
            throw new Error("");
          }
        }
      } catch (e) {
        if (e.message) {
          this.$message.error(e.message);
        }
        return;
      }

      return true;
    },
  },
  computed: {
    // 规则6 list
    dayCustomerSumAndSameRuleItemList() {
      // 药店
      if (this.queryCode == "BHOTC") {
        return this.newBizParam.dayCustomerSumAndSame.ruleItemList.filter(
          (item) => item.customerType == CustomerTypeEnum.drugstore
        );
      }
      // 商业
      if (this.queryCode == "BHSY") {
        return this.newBizParam.dayCustomerSumAndSame.ruleItemList.filter(
          (item) => item.customerType == CustomerTypeEnum.business
        );
      }
      // 医院
      if (this.queryCode == "BHRX") {
        return this.newBizParam.dayCustomerSumAndSame.ruleItemList.filter(
          (item) => item.customerType == CustomerTypeEnum.hospital
        );
      }
      return [];
    },
    // 规则7 list
    dayCustomerSameSumRuleItemList() {
      // 药店
      if (this.queryCode == "BHOTC") {
        return this.newBizParam.dayCustomerSameSum.ruleItemList.filter(
          (item) => item.customerType == CustomerTypeEnum.drugstore
        );
      }
      // 商业
      if (this.queryCode == "BHSY") {
        return this.newBizParam.dayCustomerSameSum.ruleItemList.filter(
          (item) => item.customerType == CustomerTypeEnum.business
        );
      }
      // 医院
      if (this.queryCode == "BHRX") {
        return this.newBizParam.dayCustomerSameSum.ruleItemList.filter(
          (item) => item.customerType == CustomerTypeEnum.hospital
        );
      }
      return [];
    },
    // 规则8 list
    monthCustomerSameStaffRuleItemList() {
      // 药店
      if (this.queryCode == "BHOTC") {
        return this.newBizParam.monthCustomerSameStaff.ruleItemList.filter(
          (item) => item.customerType == CustomerTypeEnum.drugstore
        );
      }
      // 商业
      if (this.queryCode == "BHSY") {
        return this.newBizParam.monthCustomerSameStaff.ruleItemList.filter(
          (item) => item.customerType == CustomerTypeEnum.business
        );
      }
      // 医院
      if (this.queryCode == "BHRX") {
        return this.newBizParam.monthCustomerSameStaff.ruleItemList.filter(
          (item) => item.customerType == CustomerTypeEnum.hospital
        );
      }
      return [];
    },
    // 规则9 list
    monthCustomerDifferentStaffRuleItemList() {
      // 药店
      if (this.queryCode == "BHOTC") {
        return this.newBizParam.monthCustomerDifferentStaff.ruleItemList.filter(
          (item) => item.customerType == CustomerTypeEnum.drugstore
        );
      }
      // 商业
      if (this.queryCode == "BHSY") {
        return this.newBizParam.monthCustomerDifferentStaff.ruleItemList.filter(
          (item) => item.customerType == CustomerTypeEnum.business
        );
      }
      // 医院
      if (this.queryCode == "BHRX") {
        return this.newBizParam.monthCustomerDifferentStaff.ruleItemList.filter(
          (item) => item.customerType == CustomerTypeEnum.hospital
        );
      }
      return [];
    },
  },
};
</script>

<style scoped>
.rule {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-bottom: 10px;
}

.w260 {
  width: 260px;
}

.w130 {
  width: 130px;
}

.rule-input-box {
  width: 90px;
}

.txt {
  margin: 0 10px;
  /* flex-shrink: 0; */
}

.theme-color {
  color: #4fa1a4;
  font-style: normal;
}
.tips-color {
  color: red;
  font-style: normal;
}
.rule-child {
  padding-left: 24px;
  padding-top: 10px;
  padding-bottom: 10px;
  background: #fafafa;
  margin-bottom: 10px;
  margin-left: 140px;
}
.rule-title {
  display: flex;
  flex-shrink: 0;
}

.tips {
  color: red;
  font-size: 12px;
}

.red-border {
  border: 1px solid red;
  border-radius: 4px;
}

.red-border /deep/ .el-input__inner {
  border: 0 none;
}

span {
  display: inline-block;
}
.rule-child .rule:last-child {
  margin-bottom: 0px;
}
.bh-config-title {
  margin-right: 10px;
  width: 126px;
  text-align: left;
}
h5 {
  font-size: 14px;
  color: #212212;
  width: 140px;
  text-align: left;
  margin: 0;
  flex-shrink: 0;
  font-weight: normal;
}
</style>
